{
  "version": 1,
  "sourceLocale": "en",
  "defaultRuntimeLocale": "en",
  "firstProductionLocales": ["en-US", "en-GB", "fr", "de", "es"],
  "locales": {
    "en": {
      "englishName": "English",
      "nativeName": "English",
      "labelKey": "settings.language.option.en",
      "direction": "ltr",
      "catalog": "en/common.json",
      "fallbackLocale": null,
      "activationStatus": "source",
      "runtimeSelectable": true,
      "translationReviewRequired": false
    },
    "en-US": {
      "englishName": "English (United States)",
      "nativeName": "English (United States)",
      "labelKey": "settings.language.option.en-US",
      "direction": "ltr",
      "catalog": "en/common.json",
      "fallbackLocale": "en",
      "activationStatus": "regional-english-source-reviewed",
      "runtimeSelectable": true,
      "translationReviewRequired": false
    },
    "en-GB": {
      "englishName": "English (United Kingdom)",
      "nativeName": "English (United Kingdom)",
      "labelKey": "settings.language.option.en-GB",
      "direction": "ltr",
      "catalog": "en/common.json",
      "fallbackLocale": "en",
      "activationStatus": "regional-english-source-reviewed",
      "runtimeSelectable": true,
      "translationReviewRequired": false
    },
    "fr": {
      "englishName": "French",
      "nativeName": "Français",
      "labelKey": "settings.language.option.fr",
      "direction": "ltr",
      "catalog": null,
      "fallbackLocale": "en",
      "activationStatus": "translation-review-required",
      "runtimeSelectable": false,
      "translationReviewRequired": true
    },
    "de": {
      "englishName": "German",
      "nativeName": "Deutsch",
      "labelKey": "settings.language.option.de",
      "direction": "ltr",
      "catalog": null,
      "fallbackLocale": "en",
      "activationStatus": "translation-review-required",
      "runtimeSelectable": false,
      "translationReviewRequired": true
    },
    "es": {
      "englishName": "Spanish",
      "nativeName": "Español",
      "labelKey": "settings.language.option.es",
      "direction": "ltr",
      "catalog": null,
      "fallbackLocale": "en",
      "activationStatus": "translation-review-required",
      "runtimeSelectable": false,
      "translationReviewRequired": true
    }
  }
}
